import { findTasksByDni } from "tasks/api"
import { updateTaskUseCaseByClient } from "tasks/services/updateTaskUseCase"
import { saveClient } from "../api"

const updateClientUseCase = async(client) => {
    const tasksData = await findTasksByDni(client.id)
    const tasks = tasksData.docs

    const { phone, name: clientName } = client
    const tasksWithClient = tasks.map(taskData => {
        const id = taskData.id
        const task = taskData.data()
        return {...task, id, phone, clientName }
    })

    for (const task of tasksWithClient) {
        await updateTaskUseCaseByClient(task, task)
    }

    client.lastUpdated = new Date().getTime()
    return saveClient(client)
}

export default updateClientUseCase